import DatePicker from 'react-datepicker';
import format from 'date-fns/format';
import subDays from 'date-fns/subDays';
import 'react-datepicker/dist/react-datepicker.css';
import './AccountCreationDateSelector.css';

type AccountCreationDateSelectorProps = {
  baseDate: Date;
  creationDate: Date;
  daysInPast: string;
  maxDaysInPast: number;
  onDaysInPastChange: (value: string) => void;
  onDateChange: (date: Date | null) => void;
  disabled?: boolean;
};

export default function AccountCreationDateSelector({
  baseDate,
  creationDate,
  daysInPast,
  maxDaysInPast,
  onDaysInPastChange,
  onDateChange,
  disabled = false,
}: AccountCreationDateSelectorProps) {
  return (
    <div className="field account-creation-date-selector">
      <div className="ui fluid labeled input account-creation-date-selector__row">
        <div className="ui label">Days in Past</div>
        <input
          type="number"
          min="0"
          max={maxDaysInPast}
          aria-label="Days in Past"
          value={daysInPast}
          onChange={(event) => onDaysInPastChange(event.target.value)}
          disabled={disabled}
        />
        <DatePicker
          customInput={
            <button
              type="button"
              className="ui label account-creation-date-selector__trigger"
              aria-label="Choose Account Creation Date"
            >
              {format(creationDate, 'yyyy-MM-dd')}
              <i className="dropdown icon" aria-hidden="true" />
            </button>
          }
          selected={creationDate}
          onChange={onDateChange}
          minDate={subDays(baseDate, maxDaysInPast)}
          maxDate={baseDate}
          disabled={disabled}
          popperPlacement="bottom-end"
        />
      </div>
    </div>
  );
}
